/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEmploymentAppData} from '../api'

export const useMutationUpdateEmploymentAppData = createReactQueryMutationHook('updateEmploymentAppData', updateEmploymentAppData)
